import { Airport, Region } from '@lib/interfaces';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { DateSelectorParts } from '@lib/components';
import { AirportListParts } from '@lib/components/shared-ui-components/airport/airport.state';

/** 複雑旅程1区間の入力値定義 */
export type FormBound = {
  /** 出発地 */
  originLocation: Airport | null;
  /** 到着地 */
  destinationLocation: Airport | null;
  /** 出発日 */
  departureDate: Date | null;
  /** 出発地 */
  originLocationFormControl: FormControl;
  /** 到着地 */
  destinationLocationFormControl: FormControl;
  /** 出発日 */
  departureDateFormControl: FormControl;
  /** 出発時間帯 */
  departureTimeWindow: FormControl;
  /** 出発時間帯フォームコントロールのサブスクリプション */
  subscriptionDepartureTimeWindow: Subscription | null;
  /** 画面項目コンポーネントに渡す設定値*/
  airportListPartsFrom?: AirportListParts;
  /** 画面項目コンポーネントに渡す設定値*/
  airportListPartsTo?: AirportListParts;
  /** 画面項目コンポーネントに渡す設定値*/
  dateSelectorParts?: DateSelectorParts;
};

export interface TestSsnDynamicParams {
  testNumber: number;
  testString: string;
}

export const ssnTestRegions: Region[] | undefined = [
  {
    name: '日本',
    english_name: '',
    code: '01',
    display_type: '1',
    area: '4',
    order: 1,
    index_list: '',
    index_list_type: null,
  },
  {
    name: 'アメリカ',
    english_name: '',
    code: '02',
    display_type: '1',
    area: '1',
    order: 2,
    index_list: "['ア', 'カ', 'サ', 'タ', 'ナ', 'ハ', 'マ', 'ヤ', 'ラ', 'ワ']",
    index_list_type: 0,
  },
];
export const ssnTestAirports: Airport[] | undefined = [
  {
    name: '札幌(新千歳)',
    english_name: 'Sapporo(New Chitose)',
    airport_code: 'CTS',
    search_for_airport_code: 'CTS',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 6,
    order: 10,
    index: '',
    display_type: '1',
  },
  {
    name: '利尻',
    english_name: 'Rishiri',
    airport_code: 'RIS',
    search_for_airport_code: 'RIS',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 20,
    index: '',
    display_type: '1',
  },
  {
    name: '稚内',
    english_name: 'Wakkanai',
    airport_code: 'WKJ',
    search_for_airport_code: 'WKJ',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 30,
    index: '',
    display_type: '1',
  },
  {
    name: 'オホーツク紋別',
    english_name: 'Okhotsk Monbetsu',
    airport_code: 'MBE',
    search_for_airport_code: 'MBE',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 40,
    index: '',
    display_type: '1',
  },
  {
    name: '女満別',
    english_name: 'Memanbetsu',
    airport_code: 'MMB',
    search_for_airport_code: 'MMB',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 50,
    index: '',
    display_type: '1',
  },
  {
    name: '旭川',
    english_name: 'Asahikawa',
    airport_code: 'AKJ',
    search_for_airport_code: 'AKJ',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 60,
    index: '',
    display_type: '1',
  },
  {
    name: 'ニューヨーク(全て)',
    english_name: 'New York(All)',
    airport_code: 'NYC',
    search_for_airport_code: 'NYC',
    region_code: '02',
    low_frequency_flag: false,
    frequency_used: 6,
    order: 50853,
    index: 'ナ',
    display_type: '1',
  },
  {
    name: 'ニューヨーク(EWR)',
    english_name: 'New York(EWR)',
    airport_code: 'EWR',
    search_for_airport_code: 'EWR',
    region_code: '02',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 50854,
    index: 'ナ',
    display_type: '1',
  },
  {
    name: 'ニューヨーク(JFK)',
    english_name: 'New York(JFK)',
    airport_code: 'JFK',
    search_for_airport_code: 'JFK',
    region_code: '02',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 50855,
    index: 'ナ',
    display_type: '1',
  },
  {
    name: 'ニューヨーク(LGA)',
    english_name: 'New York(LGA)',
    airport_code: 'LGA',
    search_for_airport_code: 'LGA',
    region_code: '02',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 50856,
    index: 'ナ',
    display_type: '1',
  },
];
